import { Alert, Button, icon, TextRegular } from "@hm/fundamental"

interface WarningAlertProps {
	dataCy: string
	text: string
	closeAriaLabel: string
	onClose: () => void
	variant?: "warning" | "error"
}

export const WarningAlert: React.FC<WarningAlertProps> = ({
	dataCy,
	text,
	closeAriaLabel,
	onClose,
	variant = "warning",
}) => (
	<Alert
		data-cy={dataCy}
		variant={variant}
		className="flex [&>div:nth-child(2)]:w-full"
	>
		<div className="flex items-start justify-between gap-3 w-full text-black">
			<TextRegular className="text-foreground">{text}</TextRegular>
			<Button
				data-cy={`${dataCy}-close`}
				variant="tertiary"
				type="button"
				size="small"
				icon={icon.mdiClose}
				onClick={onClose}
				aria-label={closeAriaLabel}
			/>
		</div>
	</Alert>
)
